export const AUTH_TOKEN = "auth_token";
export const COMPANY_ID = "company_id";
export const FACTORY_ID = "factory_id";
export const USER_ID = "user_id";
export const UPLOADED_IMAGE_PATH =
  "https://s3-ap-southeast-1.amazonaws.com/file.sugarcmms/AutoCadImages/";
export const UPLOADED_FILE_PATH =
  "https://s3-ap-southeast-1.amazonaws.com/file.sugarcmms/AutoCadFiles/";
export const REQUIRED_MSG = [
  {
    required: true,
    message: "This field is required!",
  },
];

 export const USERPERMISSIONLIST="userPermission_list";
 export const ROLESLIST="roles_list";
//  export const LANG_KEY="lang_key";